import { render } from "./UnderConstruction.vue?vue&type=template&id=0c2827c6&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"

import "./UnderConstruction.vue?vue&type=style&index=0&id=0c2827c6&scoped=true&lang=css"

import exportComponent from "F:\\Anas\\react\\aqlawfir_7-5-25\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2827c6"]])

export default __exports__